import SectionBox from './SectionBox';

export default SectionBox;
